export const home = {
  seo: {
    title: 'Bistroo - Bestelsoftware voor Restaurants & Horeca',
    description: 'De meest betaalbare en flexibele (white-label) bestelsoftware voor restaurants. Beheer (online) bestellingen, behoud klantdata en versterk je eigen merk.',
  },
  hero: {
    pill: {
      label: 'We simply serve',
      text: 'Restaurants',
    },

    heading: {
      title: 'Gasten bestellen via jouw eigen',
      words: ['webshop', 'website', 'kassa', 'kiosk', 'QR code'],
    },

    saving_time: 'We besparen je tijd en verhogen je winst.',
    boosting_business: 'We boosten jouw online business.',

    header_mockup_alt: 'Dashboard & Landingspagina',
    partners_alt: 'Vertrouwd door onze partners',
  },
  landing_pages: {
    heading: {
      create: 'Maak',
      your_restaurant: 'een website of webshop',
      shop_in_minutes: 'voor jouw restaurant in enkele minuten',
    },

    personalized_webshop:
      'Een gepersonaliseerde webshop en website voor jouw restaurant, binnen no-time online.',
    start_free: 'Start vandaag gratis en kies uit 1000+ aanpasbare ontwerpen.',

    actions: {
      create_your_website: 'Maak je website',
    },
  },
  key_features: {
    pill: {
      label: 'Belangrijkste functies',
      text: 'Alles wat je moet weten',
    },

    heading: 'Alles wat je nodig hebt voor online bestellen',

    personalize_order_experience:
      'Personaliseer de bestelervaring van je klanten met ons volledig aanpasbare online',
    boost_sales:
      'bestelsysteem. Ontdek de tools om jouw restaurant te laten groeien terwijl je kosten bespaart.',

    cards: {
      order_management_with_ease: {
        title: 'Eenvoudig orderbeheer.',
        text: 'Bied je klanten een gepersonaliseerde bestelervaring met ons volledig zelf configureerbare online webshop manager.',
        button: 'Bekijk de manager',
      },
      plug_and_play: {
        title: 'Plug-and-play.',
        text: 'Start binnen enkele minuten met de Bistroo Device of gebruik je eigen telefoon of laptop.',
      },
      peak_times: {
        title: 'Beheer drukke piekmomenten.',
        text: 'Pas instellingen in realtime aan.',
      },
      instant_payments: {
        title: 'Directe betalingen.',
        text: 'Betaal bestellingen op elk moment uit.',
        img_alt: 'POS handheld',
      },
      many_more: {
        title: 'En nog veel meer!',
        text: 'Wil je meer details over de beste functies?',
        button: 'Bekijk alle functies',
      },
    },
  },
  paragraphs: {
    paragraph_1: {
      title: 'Bistroo’s quick-service Kassa volledig geïntegreerd',
      text: 'Geen complexe installaties of ingewikkelde setup zoals bij traditionele kassasystemen. Vanaf slechts €15 per maand heb je toegang tot een modern kassasysteem ontworpen voor quick-service restaurants. Geen langlopende contracten, geen verborgen kosten.',
      cta: 'Bekijk Kassa',
    },
    paragraph_2: {
      title: 'In-store bestelopties klaar voor plug-and-play',
      text: 'Laat gasten eenvoudig bestellen en betalen via QR-codes en selfservice kiosken. Verminder wachtrijen, verhoog de bestelwaarde en help meer gasten zonder extra druk op je personeel. We zien doorgaans een snellere service en hogere omzet in het restaurant.',
      cta: 'Bekijk Kiosk',
      cta_2: 'Bekijk QR',
    },
    paragraph_3: {
      title: 'De enige volledig zelf te beheren service',
      text: 'Het laatste wat je als restaurant- of foodshopeigenaar wilt, is iemand moeten bellen om je menu te wijzigen. Wij geven je volledige controle over je data, producten, klanten en bestellingen!',
      cta: 'Bekijk Manager',
    },
  },
  products: {
    pill: {
      label: 'Bistroo Producten',
      text: 'Alles wat we bieden',
    },
    heading: 'Kies de oplossingen die perfect passen in het recept van jouw bedrijf',
    stop_overspending:
      'Stop met te veel betalen voor dure software vol ongebruikte functies, bespaar kosten en verhoog de efficiëntie.',
    productivity_increase:
      'We zien gemiddeld een stijging van 20% in productiviteit en omzet bij optimaal gebruik van onze oplossingen.',
    start_for_free: 'Start nu gratis',

    cards: {
      bistroo: 'Bistroo',
      webshop: {
        title: 'Webshop',
        img_alt: 'Bistroo Webshop',
        action: 'Bekijk Webshop',
      },
      page: {
        title: 'Website',
        img_alt: 'Bistroo Pagina',
        action: 'Bekijk Page',
      },
      qr: {
        title: 'QR',
        img_alt: 'Bistroo QR',
        action: 'Bekijk QR',
      },
      pos: {
        title: 'Kassa',
        img_alt: 'Bistroo Kassa',
        action: 'Bekijk Kassa',
      },
      posdevice: {
        title: 'Device',
        img_alt: 'Bistroo Device',
        action: 'Bekijk Device',
      },
      kiosk: {
        title: 'Kiosk',
        img_alt: 'Bistroo Kiosk',
        action: 'Bekijk Kiosk',
      },
      manager: {
        title: 'Manager',
        img_alt: 'Bistroo Manager',
        action: 'Bekijk Manager',
      },
    },
  },
  integrations: {
    heading: 'Gebruik plug-and-play integraties',
    text: 'Beheer en optimaliseer online bestellingen door integraties met jouw favoriete tools en kassasystemen. Wij hebben het voorbereid, koppel simpelweg wat je nodig hebt! Zo eenvoudig is het.',
    action: 'Bekijk integraties',
  },
  testimonials: {
    pill: {
      label: 'Klantverhalen',
      text: 'Wat ondernemers zeggen',
    },

    heading: 'Deze ondernemers maken al gebruik van Bistroo en zeggen..',
    empowered_our_clients: 'Ontdek hoe onze oplossingen ondernemers succes hebben gebracht!',

    testimonials: {
      hero: {
        img_alt: 'Mondie Scheepers - Two-B by Mondie',
        text: '"Bistroo bespaart ons dagelijks veel tijd en vermindert de frustratie bij onze klanten, tevens zien we een stijging in afhaalbestellingen."',
        author: 'Mondie Scheepers',
        company: 'Two-B by Mondie',
        action: 'Lees het volledige verhaal',
      },

      reviews: {
        one: {
          text: '"Met de overstap naar Bistroo hoeven we niet langer telefonische bestellingen aan te nemen, waardoor we kostbare tijd besparen en meer ruimte hebben voor de service aan onze klanten."',
          author: 'Roberta',
          company_role: 'Gastvrouw, Il Municipio',
          action: 'Lees verhaal',
        },
        two: {
          text: '"Met Bistroo besparen we al gauw meer dan 250 euro per maand. Tevens door promotie zagen we meer klanten via Bistroo binnenkomen. Dit is voor ons gunstig aangezien deze bestellingen een stuk goedkoper zijn qua kosten."',
          author: 'Hamza',
          company_role: 'Eigenaar, Grillroom Istanbul',
          action: 'Lees verhaal',
        },
        three: {
          text: '"Dankzij Bistroo hebben we meer regie over drukke momenten. Voorheen werden telefonische bestellingen soms niet aangenomen, wat mogelijk omzetverlies veroorzaakte. We zien dit duidelijk terug in onze cijfers."',
          author: 'Henk Boom',
          company_role: "Eigenaar, cafetaria D'n Boom",
          action: 'Lees verhaal',
        },
      },
    },
  },
}
